var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeabLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2028.78 744.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1ea7ac;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#010101;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M413.9,569.75v58.55c0,64.07,51.95,116.02,116.02,116.02h235.92v-58.4h-233.01c-32.09,0-58.11-25.9-58.36-57.93h272.81v-59.33h-272.8c.3-32.04,26.34-57.93,58.45-57.93h232.92v-58.39h-234.53c-64.85,0-117.42,52.57-117.42,117.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.1,627.52h181.65c0,32.25-26.15,58.4-58.4,58.4h-125.33c-32.3,0-58.47-26.18-58.47-58.48v-58.32c0-32.25,26.14-58.4,58.39-58.4h216.66v-58.39H117.41c-64.85,0-117.41,52.57-117.41,117.41v57.15c0,64.85,52.57,117.41,117.41,117.41h128.47c64.85,0,117.41-52.57,117.41-117.41v-57.78H121.1v58.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1556.43,591.35c10.55-14.49,16.84-32.27,16.84-51.56,0-48.5-39.32-87.81-87.81-87.81h-249.77v292.69h262.42c48.49,0,87.81-39.31,87.81-87.81,0-26.08-11.43-49.43-29.49-65.51ZM1296.38,510.51h186.92c16.17,0,29.27,13.11,29.27,29.28s-13.11,29.27-29.27,29.27h-186.92v-58.55ZM1495.95,686.13h-199.57v-24.62l-.15-.14v-33.78h199.71c16.17,0,29.27,13.11,29.27,29.27,0,16.17-13.11,29.27-29.27,29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M818.04,569.33v174.99h60.7v-53.95h.1v-63.13h242.69v117.08h60.7v-292.69h-246.49c-65.01,0-117.7,52.7-117.7,117.7ZM1121.53,510.16v58.54h-242.79c0-32.33,26.21-58.54,58.54-58.54h184.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1772.58,168.47h9.6l6.89-156.46c.29-6.54-4.94-12-11.49-12h-.41c-6.55,0-11.78,5.46-11.49,12l6.89,156.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1731.76,181.98l8.32-4.8-72.26-138.95c-3.02-5.81-10.28-7.93-15.95-4.65l-.35.2c-5.67,3.27-7.47,10.62-3.95,16.14l84.2,132.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1703.17,214.09l4.8-8.32-132.06-84.2c-5.52-3.52-12.87-1.73-16.14,3.95l-.2.35c-3.27,5.67-1.16,12.93,4.65,15.95l138.95,72.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1694.46,256.2v-9.6s-156.46-6.89-156.46-6.89c-6.54-.29-12,4.94-12,11.49v.41c0,6.55,5.46,11.78,12,11.49l156.46-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1707.97,297.02l-4.8-8.32-138.95,72.26c-5.81,3.02-7.93,10.28-4.65,15.95l.2.35c3.27,5.67,10.62,7.47,16.14,3.95l132.06-84.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1740.08,325.61l-8.32-4.8-84.2,132.06c-3.52,5.52-1.73,12.87,3.95,16.14l.35.2c5.67,3.27,12.93,1.16,15.95-4.65l72.26-138.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1782.18,334.32h-9.6s-6.89,156.46-6.89,156.46c-.29,6.54,4.94,12,11.49,12h.41c6.55,0,11.78-5.46,11.49-12l-6.89-156.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1823,320.81l-8.32,4.8,72.26,138.95c3.02,5.81,10.28,7.93,15.95,4.65l.35-.2c5.67-3.27,7.47-10.62,3.95-16.14l-84.2-132.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1851.6,288.7l-4.8,8.32,132.06,84.2c5.52,3.52,12.87,1.73,16.14-3.95l.2-.35c3.27-5.67,1.16-12.93-4.65-15.95l-138.95-72.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1771.71,246.6v9.6s245.24,7.08,245.24,7.08c6.48.19,11.83-5.01,11.83-11.49v-.77c0-6.48-5.35-11.68-11.83-11.49l-245.24,7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1751.28,172.54l9.27-2.49-21.91-107.57c-1.32-6.49-7.84-10.53-14.24-8.81h0c-6.4,1.71-10.03,8.47-7.93,14.75l34.81,104.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1715.35,196.15l6.79-6.79-72.76-82.2c-4.39-4.96-12.06-5.19-16.74-.51h0c-4.68,4.68-4.45,12.35.51,16.74l82.2,72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1696.04,234.57l2.49-9.27-104.11-34.81c-6.28-2.1-13.04,1.53-14.75,7.93h0c-1.71,6.4,2.32,12.92,8.81,14.24l107.57,21.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1698.53,277.49l-2.49-9.27-107.57,21.91c-6.49,1.32-10.53,7.84-8.81,14.24h0c1.71,6.4,8.47,10.03,14.75,7.93l104.11-34.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1722.14,313.43l-6.79-6.79-82.2,72.76c-4.96,4.39-5.19,12.06-.51,16.74h0c4.68,4.68,12.35,4.45,16.74-.51l72.76-82.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1760.56,332.74l-9.27-2.49-34.81,104.11c-2.1,6.28,1.53,13.04,7.93,14.75h0c6.4,1.71,12.92-2.32,14.24-8.81l21.91-107.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1803.48,330.25l-9.27,2.49,21.91,107.57c1.32,6.49,7.84,10.53,14.24,8.81h0c6.4-1.71,10.03-8.47,7.93-14.75l-34.81-104.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1839.41,306.64l-6.79,6.79,72.76,82.2c4.39,4.96,12.06,5.19,16.74.51h0c4.68-4.68,4.45-12.35-.51-16.74l-82.2-72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1858.73,268.22l-2.49,9.27,104.11,34.81c6.28,2.1,13.04-1.53,14.75-7.93h0c1.71-6.4-2.32-12.92-8.81-14.24l-107.57-21.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeabLogo2);
export default __webpack_public_path__ + "static/media/geab-logo-2.dd20f2458f0c018a60d1a97c3fa019fb.svg";
export { ForwardRef as ReactComponent };